var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("br"),
    _vm._v(" "),
    _c("h4", [_vm._v("Questions")]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    !_vm.loading && _vm.questionlist.length < 2
      ? _c("div", [_vm._v("\n    Please select a survey first\n  ")])
      : _c("div", [
          _vm._m(0),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "div",
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "spinner", size: "3x", spin: "" }
                  })
                ],
                1
              )
            : _c(
                "div",
                _vm._l(_vm.questionlist, function(question) {
                  return _vm.questionlist.length > 1
                    ? _c("question-item", {
                        key: question.id,
                        attrs: { question: question },
                        on: {
                          "update:question": function($event) {
                            _vm.updateQuestion($event)
                          }
                        }
                      })
                    : _vm._e()
                })
              )
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row font-weight-bold" }, [
      _c("div", { staticClass: "col-3" }, [
        _vm._v("\n        Question\n      ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [
        _vm._v("\n        Options\n      ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2 required small font-weight-bold" }, [
        _vm._v("\n        Measure or Topic/Element Name\n      ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-1 small font-weight-bold" }, [
        _vm._v("\n        Is Topic/Element\n      ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-1 small font-weight-bold" }, [
        _vm._v("\n        Score Inverse\n      ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-1 small font-weight-bold" }, [
        _vm._v("\n        Has Comments\n      ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00018f88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00018f88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuestionTable.vue
// module id = null
// module chunks = 